var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61038 6.44985C6.0009 6.84038 6.0009 7.47354 5.61037 7.86406L1.4201 12.0543C1.18808 12.2863 1.18808 12.6625 1.4201 12.8945C1.65211 13.1265 2.02828 13.1265 2.26029 12.8945L7.5799 7.57493C7.81191 7.34291 7.81191 6.96675 7.5799 6.73473L7.16086 6.3157C7.16028 6.31512 7.15932 6.31512 7.15874 6.3157C7.15815 6.31629 7.1572 6.31629 7.15661 6.3157L2.26103 1.4201C2.02902 1.18809 1.65285 1.18808 1.42084 1.4201C1.18882 1.65211 1.18882 2.02827 1.42084 2.26029L5.61038 6.44985Z",
    fill: "#C5C5C5",
    stroke: "#C5C5C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngle);
export default __webpack_public_path__ + "static/media/angle.56a4248ca66692d3a800b2754b2da862.svg";
export { ForwardRef as ReactComponent };